// Primary brand colors (Brand Logo Orange)
const primary = {
  lighter: '#FFF4EE',
  light: '#FF8534',
  main: '#FE5F01',
  dark: '#D94F00',
  darker: '#8C2E00',
  contrastText: '#FFFFFF',
};

// Secondary brand colors (Brand Logo Black)
const secondary = {
  lighter: '#F1F5F9',
  light: '#334155',
  main: '#0F172A',
  dark: '#020617',
  darker: '#000000',
  contrastText: '#FFFFFF',
};

// Informational (Sky blue)
const info = {
  lighter: '#F0F9FF',
  light: '#38BDF8',
  main: '#0284C7',
  dark: '#0369A1',
  darker: '#0C4A6E',
  contrastText: '#FFFFFF',
};

// Positive / Success (Emerald)
const success = {
  lighter: '#ECFDF5',
  light: '#34D399',
  main: '#059669',
  dark: '#047857',
  darker: '#064E3B',
  contrastText: '#FFFFFF',
};

// Warning (Warm Amber)
const warning = {
  lighter: '#FFFBEB',
  light: '#FBBF24',
  main: '#D97706',
  dark: '#B45309',
  darker: '#78350F',
  contrastText: '#FFFFFF',
};

// Destructive / Error (Rose red)
const error = {
  lighter: '#FEF2F2',
  light: '#F87171',
  main: '#DC2626',
  dark: '#B91C1C',
  darker: '#7F1D1D',
  contrastText: '#FFFFFF',
};

// Slate gray scale (Tailwind/Radix standard, highly readable)
const grey = {
  0: '#FFFFFF',
  50: '#F8FAFC',
  100: '#F1F5F9',
  200: '#E2E8F0',
  300: '#CBD5E1',
  400: '#94A3B8',
  500: '#64748B',
  600: '#475569',
  700: '#334155',
  800: '#1E293B',
  900: '#0F172A',
};

const lightPalette = {
  mode: 'light',
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  text: {
    primary: '#0F172A',
    secondary: '#475569',
    disabled: '#94A3B8',
  },
  background: {
    paper: '#FFFFFF',
    default: '#F8FAFC',
    neutral: '#F1F5F9',
  },
  divider: 'rgba(148, 163, 184, 0.22)',
  action: {
    active: '#475569',
    hover: 'rgba(15, 23, 42, 0.04)',
    selected: 'rgba(254, 95, 1, 0.08)',
    disabled: '#94A3B8',
    disabledBackground: 'rgba(148, 163, 184, 0.16)',
    focus: 'rgba(254, 95, 1, 0.18)',
    hoverOpacity: 0.04,
    disabledOpacity: 0.38,
  },
};

const darkPalette = {
  mode: 'dark',
  primary: {
    lighter: '#4D1C00',
    light: '#FF8534',
    main: '#FE5F01',
    dark: '#D94F00',
    darker: '#FFD5C0',
    contrastText: '#FFFFFF',
  },
  secondary: {
    lighter: '#1E293B',
    light: '#475569',
    main: '#E2E8F0',
    dark: '#F8FAFC',
    darker: '#FFFFFF',
    contrastText: '#0F172A',
  },
  info: {
    ...info,
    main: '#38BDF8',
    contrastText: '#0F172A',
  },
  success: {
    ...success,
    main: '#34D399',
    contrastText: '#0F172A',
  },
  warning: {
    ...warning,
    main: '#FBBF24',
    contrastText: '#0F172A',
  },
  error: {
    ...error,
    main: '#F87171',
    contrastText: '#0F172A',
  },
  grey,
  text: {
    primary: '#F8FAFC',
    secondary: '#94A3B8',
    disabled: '#64748B',
  },
  background: {
    paper: '#111827',
    default: '#0B0F17',
    neutral: '#1F2937',
  },
  divider: 'rgba(148, 163, 184, 0.14)',
  action: {
    active: '#94A3B8',
    hover: 'rgba(255, 255, 255, 0.05)',
    selected: 'rgba(254, 95, 1, 0.14)',
    disabled: '#64748B',
    disabledBackground: 'rgba(148, 163, 184, 0.12)',
    focus: 'rgba(254, 95, 1, 0.24)',
    hoverOpacity: 0.05,
    disabledOpacity: 0.38,
  },
};

export const getPalette = (mode) => (mode === 'dark' ? darkPalette : lightPalette);

// Backward-compatible default export
export const palette = lightPalette;
